module.exports = __webpack_public_path__ + "static/img/Netflix.ac01737f.png";